<template>
  <div class="module-config">
    <Popup />

    <v-container>
      <!-- Loading state -->
      <div v-if="isLoading" class="text-center py-8">
        <v-progress-circular indeterminate color="primary" />
        <p class="mt-4">Loading configuration...</p>
      </div>

      <!-- Module config form -->
      <div v-else>
        <ModuleConfigForm
          :customer-id="customerId"
          :customer-code="customerCode"
          :app-code="appCode"
          :module-name="moduleName"
        />
      </div>
    </v-container>
  </div>
</template>

<script>
import Popup from '../Popup.vue';
import ModuleConfigForm from './ModuleConfigForm.vue';

export default {
  name: 'CustomerDetailsModuleConfig',
  components: { Popup, ModuleConfigForm },

  data() {
    return {
      customerName: '',
      customerCode: '',
      isLoading: true,
    };
  },

  computed: {
    customerId() {
      return this.$route.params.id;
    },
    appCode() {
      return this.$route.params.appCode;
    },
    moduleName() {
      // Normalize moduleName from external redirects (e.g. MS OAuth).
      // The backend may return underscores (ai_order_import) or URI-encoded spaces (%20).
      // Canonicalize to spaces so all component logic comparing against 'ai order import' works.
      const rawModuleName = this.$route.params.moduleName;
      return decodeURIComponent(rawModuleName).replace(/_/g, ' ');
    },
    pageTitle() {
      return `${this.getAppDisplayName(this.appCode)} ${this.formatModuleName(this.moduleName)} for ${this.customerName}`;
    },
  },

  watch: {
    pageTitle: {
      immediate: false,
      handler(newTitle) {
        if (this.customerName) {
          this.$store.commit('setCustomPageTitle', newTitle);
        }
      },
    },
  },

  methods: {
    async loadCustomerData() {
      this.isLoading = true;
      try {
        const response = await this.$http.get(`/api/customers/${this.customerId}`);
        this.customerName = response.data.name;
        this.customerCode = response.data.code;

        this.$store.commit('setCustomPageTitle', this.pageTitle);
      } catch (error) {
        this.showAlertPopup('Error loading customer data', 'error');
      } finally {
        this.isLoading = false;
      }
    },

    getAppDisplayName(appCode) {
      const displayNames = {
        KOA: 'FoodOrder',
        DDN: 'Lieferschein',
        FOR1: 'FoodOffice R1',
      };
      return displayNames[appCode] || appCode;
    },

    formatModuleName(name) {
      return name
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
    },

    showAlertPopup(message, type = 'error') {
      this.$store.state.popupAlertStatus = true;
      this.$store.state.popupAlertMessage = message;
      this.$store.state.popupAlertType = type;
    },
  },

  mounted() {
    this.$store.state.showCdLinks = true;
  },

  created() {
    this.loadCustomerData();
  },

  destroyed() {
    this.$store.state.showCdLinks = false;
    this.$store.commit('clearCustomPageTitle');
  },
};
</script>

<style scoped lang="scss">
.module-config {
  width: 100%;
}
</style>
